import { CreateBalanceSheetModalBody } from '@/modules/clientOnboarding/ClientOnboardingDeliverableModal/modalBodies/CreateBalanceSheetModalBody';

import {
  ClientOnboardingDeliverableStep,
  ClientOnboardingDeliverableVariant,
} from '../types';
import { BuildOutHouseholdModalBody } from './modalBodies/BuildOutHouseholdModalBody';
import { CreateAnalysisModalBody } from './modalBodies/CreateAnalysisModalBody';
import { CreateEntityOverviewModalBody } from './modalBodies/CreateEntityOverviewModalBody';
import { GenerateEstateSnapshotModalBody } from './modalBodies/GenerateEstateSnapshotModalBody';
import { SummarizeDocumentModalBody } from './modalBodies/SummarizeDocumentModalBody';

interface ClientOnboardingDeliverableModalBodyProps {
  variant: ClientOnboardingDeliverableVariant;
  onClose: () => void;
  onChildPhaseChange?: (phase: ClientOnboardingDeliverableStep) => void;
}

export function ClientOnboardingDeliverableModalBody({
  variant,
  ...props
}: ClientOnboardingDeliverableModalBodyProps) {
  switch (variant) {
    case ClientOnboardingDeliverableVariant.SUMMARIZE_DOCUMENT:
      return <SummarizeDocumentModalBody {...props} />;
    case ClientOnboardingDeliverableVariant.CREATE_ENTITY_OVERVIEW:
      return <CreateEntityOverviewModalBody {...props} />;
    case ClientOnboardingDeliverableVariant.BUILD_OUT_HOUSEHOLD:
      return <BuildOutHouseholdModalBody {...props} />;
    case ClientOnboardingDeliverableVariant.CREATE_ANALYSIS:
      return <CreateAnalysisModalBody />;
    case ClientOnboardingDeliverableVariant.CREATE_BALANCE_SHEET:
      return <CreateBalanceSheetModalBody {...props} />;
    case ClientOnboardingDeliverableVariant.GENERATE_ESTATE_SNAPSHOT:
      return <GenerateEstateSnapshotModalBody {...props} />;
    default:
      return null;
  }
}
